import { render, staticRenderFns } from "./creditsAndRefundsMobile.vue?vue&type=template&id=a5f2cbc2&scoped=true&"
import script from "./creditsAndRefundsMobile.vue?vue&type=script&lang=js&"
export * from "./creditsAndRefundsMobile.vue?vue&type=script&lang=js&"
import style0 from "./creditsAndRefundsMobile.vue?vue&type=style&index=0&id=a5f2cbc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f2cbc2",
  null
  
)

export default component.exports